import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClipboard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconClipboard2"><Path fillRule="evenodd" clipRule="evenodd" d="M7 2.75C7 2.33579 7.33579 2 7.75 2H16.25C16.6642 2 17 2.33579 17 2.75V4H20.25C20.6642 4 21 4.33579 21 4.75V21.25C21 21.6642 20.6642 22 20.25 22H3.75C3.33579 22 3 21.6642 3 21.25V4.75C3 4.33579 3.33579 4 3.75 4H7V2.75ZM8.5 6.5H15.5V3.5H8.5V6.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconClipboard2;
